import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HRRoutingModule } from './hr-routing.module';
import { HRComponent } from './hr.component';
import { PremissionComponent } from './premission/premission.component';
import { SharedModule } from 'src/app/shared/modules/shared/shared.module';
import { HolidayComponent } from './holiday/holiday.component';
import { AllowanceComponent } from './allowance/allowance.component';
import { DeductionComponent } from './deduction/deduction.component';
import { PublicHolidayComponent } from './public-holiday/public-holiday.component';
import { DurationWorkSystemComponent } from './duration-work-system/duration-work-system.component';
import { BreakDurationComponent } from './break-duration/break-duration.component';
import { RewardsComponent } from './worksystemSetting/rewards/rewards.component';
import { PenalitesComponent } from './worksystemSetting/penalites/penalites.component';
import { EmployeeDurationDataComponent } from './employee-duration-data/employee-duration-data.component';
import { DropdownComponent } from './employee-duration-data/employee-duration/dropdown/dropdown.component';
import { EmployeeDurationComponent } from './employee-duration-data/employee-duration/employee-duration.component';
import { PermissionHeaderWorkSystemComponent } from './permission-header-work-system/permission-header-work-system.component';
import { AddEditPermissionHeaderWorkSystemComponent } from './permission-header-work-system/add-edit-permission-header-work-system/add-edit-permission-header-work-system.component';
import { HolidayHeaderSystemComponent } from './holiday-header-system/holiday-header-system.component';
import { AddEditHolidayHeaderSystemComponent } from './holiday-header-system/add-edit-holiday-header-system/add-edit-holiday-header-system.component';
import { DetailGridComponent } from './holiday-header-system/add-edit-holiday-header-system/detail-grid/detail-grid.component';
import { DeductionRulesComponent } from './worksystemSetting/deduction-rules/deduction-rules.component';
import { SharedComponentModule } from 'src/app/shared-component/shared-component.module';
import { ExtraTimeRulesComponent } from './worksystemSetting/extra-time-rules/extra-time-rules.component';
import { AttendingLeavingComponent } from './attending-leaving/attending-leaving.component';
import { AttendingLeavingFilterComponent } from './attending-leaving/attending-leaving-filter/attending-leaving-filter.component';
import { AttendingLeavingDataComponent } from './attending-leaving/attending-leaving-data/attending-leaving-data.component';
import { AttendingLeavingFromExcelComponent } from './attending-leaving/attending-leaving-from-excel/attending-leaving-from-excel.component';
import { DelayRuleComponent } from './worksystemSetting/deduction-rules/delay-rule/delay-rule.component';
import { AbsenceRuleComponent } from './worksystemSetting/deduction-rules/absence-rule/absence-rule.component';
import { ExtraDetailComponent } from './worksystemSetting/extra-time-rules/extra-detail/extra-detail.component';
import { AbsenceRuleHeaderSystemComponent } from './absence-rule-header-system/absence-rule-header-system.component';
import { AddEditAbsenceRuleHeaderSystemComponent } from './absence-rule-header-system/add-edit-absence-rule-header-system/add-edit-absence-rule-header-system.component';
import { DelayRuleHeaderSystemComponent } from './delay-rule-header-system/delay-rule-header-system.component';
import { AddEditDelayRuleHeaderSystemComponent } from './delay-rule-header-system/add-edit-delay-rule-header-system/add-edit-delay-rule-header-system.component';
import { ExtraTimeRuleHeaderSystemComponent } from './extra-time-rule-header-system/extra-time-rule-header-system.component';
import { AddEditExtraTimeRuleHeaderSystemComponent } from './extra-time-rule-header-system/add-edit-extra-time-rule-header-system/add-edit-extra-time-rule-header-system.component';
import { EmployeeSystemsComponent } from './employee-systems/employee-systems.component';
import { EmployeeSystemsDataComponent } from './employee-systems/employee-systems-data/employee-systems-data.component';
import { EmployeeRequestsComponent } from './employee-requests/employee-requests.component';
import { EmployeeAttachmentTypeComponent } from './employee-attachment-type/employee-attachment-type.component';
import { EmployeeAttachmentComponent } from './employee-attachment/employee-attachment.component';
import { AddAttachmentComponent } from './employee-attachment/add-attachment/add-attachment.component';
import { ChangeStatusComponent } from './change-employee-status/change-status/change-status.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ImportAttendingLeavingComponent } from './import-attending-leaving/import-attending-leaving.component';
import { EmployeeResignationComponent } from './employee-resignation/employee-resignation.component';
import { ApproveEmployeeResignationComponent } from './approve-employee-resignation/approve-employee-resignation.component';
import { HeadersTitleModule } from 'src/app/shared/modules/shared/HeadersTitle/HeadersTitle.module';
import { ChangeEmployeeStatusComponent } from './change-employee-status/change-employee-status.component';
import { FingerPrintDevicesComponent } from './finger-print-devices/finger-print-devices.component';
import { ImportFingerPrintComponent } from './import-finger-print/import-finger-print.component';
import { GeneralCalcSalaryInputsComponent } from './general-calc-salary-inputs/general-calc-salary-inputs.component';
import { VacationRequestComponent } from './vacation-request/vacation-request.component';
import { ApprovelVacationRequestComponent } from './approvel-vacation-request/approvel-vacation-request.component';
import { ShowEmployeeWorkDurationsComponent } from './show-employee-work-durations/show-employee-work-durations.component';
import { EmployeeMissionComponent } from './employee-mission/employee-mission.component';
import { AddEditEmployeeMissionComponent } from './add-edit-employee-mission/add-edit-employee-mission.component';
import { EditAttendingLeavingComponent } from './attending-leaving/edit-attending-leaving/edit-attending-leaving.component';





@NgModule({
  declarations: [
    HRComponent,
    PremissionComponent,
    HolidayComponent,
    AllowanceComponent,
    DeductionComponent,
    PublicHolidayComponent,
    DurationWorkSystemComponent,
    BreakDurationComponent,
    RewardsComponent,
    PenalitesComponent,
    EmployeeDurationComponent,
    DropdownComponent,
    EmployeeDurationDataComponent,
    PermissionHeaderWorkSystemComponent,
    AddEditPermissionHeaderWorkSystemComponent,
    HolidayHeaderSystemComponent,
    AddEditHolidayHeaderSystemComponent,
    DetailGridComponent,
    DeductionRulesComponent,
    ExtraTimeRulesComponent,
    AttendingLeavingComponent,
    AttendingLeavingFilterComponent,
    AttendingLeavingDataComponent,
    AttendingLeavingFromExcelComponent,
    DelayRuleComponent,
    AbsenceRuleComponent,
    ExtraDetailComponent,
     EditAttendingLeavingComponent
    ,
    AbsenceRuleHeaderSystemComponent,
    AddEditAbsenceRuleHeaderSystemComponent,
    DelayRuleHeaderSystemComponent,
    AddEditDelayRuleHeaderSystemComponent,
    ExtraTimeRuleHeaderSystemComponent,
    AddEditExtraTimeRuleHeaderSystemComponent,
    EmployeeSystemsComponent,
    EmployeeSystemsDataComponent,
    EmployeeRequestsComponent,
    EmployeeAttachmentTypeComponent,
    EmployeeAttachmentComponent,
    AddAttachmentComponent,
    ChangeStatusComponent,
    ImportAttendingLeavingComponent,
    EmployeeResignationComponent,
    ApproveEmployeeResignationComponent,
    FingerPrintDevicesComponent,
    ImportFingerPrintComponent,
    GeneralCalcSalaryInputsComponent,
    VacationRequestComponent,
    ApprovelVacationRequestComponent,
    ShowEmployeeWorkDurationsComponent,
    EmployeeMissionComponent,
    AddEditEmployeeMissionComponent,
    EditAttendingLeavingComponent,
    
    
    ],
  imports: [
    CommonModule,
    HRRoutingModule,
    SharedModule,
    SharedComponentModule,
    ReactiveFormsModule,
    HeadersTitleModule
  ],
  exports: [
    DropdownComponent,
    ExtraTimeRuleHeaderSystemComponent,
    GeneralCalcSalaryInputsComponent
  ]
})
export class HRModule { }
